export enum MfaStatus {
    Initialized = 'Initialized',
    TryAgain = 'TryAgain',
    Passed = 'Passed',
    Failed = 'Failed',
    Locked = 'Locked',
    /**
     * Temporary cooldown on a SEND/resend: the per-destination issuance cap was hit,
     * so a new code can't be sent right now (~10 minutes). The BFF returns this on
     * SendCode / SendEmailCode / ResendEmailLoginCode (security 9073 / MfaInCooldown).
     */
    Cooldown = 'Cooldown'
}